import React from 'react'
import BrightInsights from 'src/components/bright-insights';

const  BrightInsightComp = () => {
  return (
    <div> <BrightInsights /> </div>
  )
}

export default  BrightInsightComp;